import React from 'react';
import { StarIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Results() {
  const results = ['saber exactamente cuánto puedes gastar sin culpa', 'pagar deudas con un plan claro (y ver progreso)', 'empezar a ahorrar aunque sea poco', 'dejar de vivir al límite cada mes', 'sentir estabilidad y control'];
  return <section className="py-24 relative" data-id="element-234">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-235">
        <FadeIn data-id="element-236">
          <div className="text-center mb-16" data-id="element-237">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-238">
              Resultados que puedes esperar
            </h2>
            <p className="text-xl text-gold-500 italic" data-id="element-239">(si aplicas el plan)</p>
          </div>
        </FadeIn>

        <div className="grid gap-4" data-id="element-240">
          {results.map((result, index) => <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-241">
              <div className="glass-card relative overflow-hidden flex items-center gap-6 group" data-id="element-242">
                {/* Left gold border accent */}
                <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gold-500 transform origin-bottom scale-y-0 group-hover:scale-y-100 transition-transform duration-300" data-id="element-243" />

                <div className="bg-white/5 p-3 rounded-full text-gold-400 group-hover:text-gold-500 group-hover:scale-110 transition-all" data-id="element-244">
                  <StarIcon className="w-6 h-6" data-id="element-245" />
                </div>

                <p className="text-lg md:text-xl text-white font-medium" data-id="element-246">
                  {result}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}